import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './AuthContext';

/**
 * Access the current AuthContext value. Throws outside an <AuthProvider> —
 * always-true at runtime because the provider wraps the whole app, but the
 * runtime guard catches accidental usage in misconfigured tests.
 */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>');
  return ctx;
}
